import {
  Button,
  Disclosure,
  DisclosureGroup,
  DisclosurePanel,
} from 'react-aria-components';
import styled from 'styled-components';

export const Group = styled(DisclosureGroup)`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
`;

export const Option = styled(Disclosure)`
  &[data-focus-visible-within] {
    box-shadow: var(--shadow-focus);
    border: 1px solid var(--brand-600);

    & :focus-visible {
      outline: 0;
    }
  }
`;

export const Trigger = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--spacing-small);
  width: 100%;
  max-width: 422px;
  padding: var(--spacing-large);
  background: var(--white);
  border-color: var(--grey-300);
  border-radius: var(--radius-base);
  border-style: solid;
  border-width: 1px 1px 0 1px;
  border-width: 1px 1px 0 1px;

  :first-of-type > & {
    border-radius: var(--radius-base) var(--radius-base) 0 0;
  }

  :last-of-type > & {
    border-radius: 0 0 var(--radius-base) var(--radius-base);
    border-bottom-width: 1px;
  }

  [data-expanded] > & {
    background: var(--grey-100);
    border-color: var(--brand-900);
    border-bottom-width: 1px;
  }

  :last-of-type[data-expanded] > & {
    border-radius: 0;
  }
`;

export const RadioButton = styled.div`
  display: block;
  width: 18px;
  height: 18px;
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-fullyrounded);

  &:is([data-expanded] &) {
    border: 6px solid var(--brand-900);
  }

  &:is([data-focus-visible] &) {
    box-shadow: 0 0 0 2px var(--white), 0 0 0 4px rgb(15 23 43);
  }
`;

export const Label = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xsmall);
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-regular);
  line-height: 1.5rem;
  color: var(--black);
  text-align: left;
`;

export const Panel = styled(DisclosurePanel)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  width: 100%;
  max-width: 422px;
  padding: var(--spacing-base);
  background: var(--grey-50);
  border: 1px solid var(--grey-300);

  &[hidden="until-found"] {
    padding: 0;
    border: 0;
  }

  :first-of-type > & {
    border-block-end: 0;
  }

  :last-of-type > & {
    border-radius: 0 0 var(--radius-base) var(--radius-base); 
  }

  :last-of-type > &:not([hidden]) {
    border-block-end: 1px solid var(--grey-300);
  }
`;

export const ErrorText = styled.p`
  margin-block-end: var(--spacing-small);
  font-size: var(--font-size-text-sm);
  font-weight: var(--font-weight-bold);
  color: var(--error-600);
`;
